/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCommonModule } from '@angular/material/core';
import { MatProgressBar } from './progress-bar';
export class MatProgressBarModule {
}
MatProgressBarModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, MatCommonModule],
                exports: [MatProgressBar, MatCommonModule],
                declarations: [MatProgressBar],
            },] },
];
/**
 * @nocollapse
 */
MatProgressBarModule.ctorParameters = () => [];
function MatProgressBarModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatProgressBarModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatProgressBarModule.ctorParameters;
}
//# sourceMappingURL=progress-bar-module.js.map